import React, { createContext, useContext, useEffect, useState } from 'react';

const OfferContext = createContext();

export const OfferProvider = ({ children }) => {
  const [house, setHouse] = useState(null);
  const [offerResult, setOfferResult] = useState(null);
  const [manualDiscounts, setManualDiscounts] = useState([]);
  const [manualAdditionalPayments, setManualAdditionalPayments] = useState([]);
  const [canModifyPayments, setCanModifyPayments] = useState(false);
  const [reservationId, setReservationId] = useState();
  const [paymentModel, setPaymentModel] = useState();
  const [paymentOnBookingPercentage, setPaymentOnBookingPercentage] = useState();


  const [offerLoaded, setOfferLoaded] = useState(false);
  const [offerAvailableToSell, setOfferAvailableToSell] = useState(false);

  useEffect(() => {
    setOfferLoaded(!!offerResult?.result);
    setOfferAvailableToSell(!!offerResult?.result?.available);
  }, [offerResult]);


  return (
    <OfferContext.Provider
      value={{
        house,
        setHouse,
        offerResult,
        setOfferResult,
        manualDiscounts,
        setManualDiscounts,
        canModifyPayments,
        setCanModifyPayments,
        reservationId,
        paymentModel,
        setPaymentModel,
        paymentOnBookingPercentage,
        setPaymentOnBookingPercentage,
        manualAdditionalPayments,
        setManualAdditionalPayments,
        offerLoaded,
        offerAvailableToSell,
      }}
    >
      {children}
    </OfferContext.Provider>
  );
};

export const useOffer = () => {
  const context = useContext(OfferContext);
  if (!context) {
    throw new Error('useOffer must be used within an OfferProvider');
  }
  return context;
};
